import React from 'react';
import LargeWidthContainer from '../../../Layout/Containers/LargeWidthContainer';
import { StrapiCoverImageComponent } from '../../MediaComponent/MediaComponent';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import Link from 'next/link';
import styles from './renderTargetGroup.module.scss';
import { SingleTargetGroupPageProps } from '../../../Models/PageProps';
import InsuranceContactComponent from '../../../Contact/InsuranceContactComponent';
import SolutionCards from '../SolutionCards/SolutionCards';
import RelatedArticlesComponent from '../../../RelatedArticles/RelatedArticlesComponent';

const RenderCoverImageSection = ({ coverImage }: any) => {
    if (!coverImage) {
        return null;
    }
    return (
        <LargeWidthContainer>
            <StrapiCoverImageComponent
                strapiImage={coverImage.picture}
                styles={{ width: '100%', height: '476px' }}
                className={styles.fullCoverImage}
            >
                <div className={styles.cover}>
                    <BlocksRenderer content={coverImage.paragraph}></BlocksRenderer>
                    <div className={styles.links}>
                        <Link href="#contact-banner" className={'button-link-inverted'}>
                            <span>Contact us &#10132;</span>
                        </Link>
                    </div>
                </div>
            </StrapiCoverImageComponent>
        </LargeWidthContainer>
    );
};

const RenderIntroductionSection = ({ introduction }: any) => {
    if (!introduction) {
        return null;
    }
    return (
        <LargeWidthContainer>
            <div className={styles.introduction}>
                <BlocksRenderer content={introduction.paragraph}></BlocksRenderer>
            </div>
        </LargeWidthContainer>
    );
};

const RenderTargetGroup = ({
    content,
    solutions,
    relatedArticles,
    children,
}: SingleTargetGroupPageProps) => {
    if (!content) {
        return null;
    } else {
        return (
            <>
                {children}
                <RenderCoverImageSection
                    coverImage={content['coverImage']}
                ></RenderCoverImageSection>
                <RenderIntroductionSection
                    introduction={content['introduction']}
                ></RenderIntroductionSection>
                <SolutionCards solutions={solutions}></SolutionCards>
                <div id="contact-banner" className={styles.contact}>
                    <InsuranceContactComponent />
                </div>
                <RelatedArticlesComponent articles={relatedArticles}></RelatedArticlesComponent>
            </>
        );
    }
};

export default RenderTargetGroup;
